import Text from "common/Typography/Text";
import { useTheme } from "styled-components";
import { UsageLimitValue, UsageType } from "@shared/types";
import { InfinityIcon } from "common/Icons/Icons";
import { useQuotaTest } from "@shared/features/settings/hooks";

interface CurrentUsageValueProps {
  currentUsage?: UsageLimitValue;
  usageLimit?: UsageLimitValue;
  usageType: UsageType;
}

const CurrentUsageValue = ({
  currentUsage,
  usageLimit,
  usageType,
}: CurrentUsageValueProps) => {
  const theme = useTheme();
  const { testQuota, getTotalQuota } = useQuotaTest();

  let color = theme.colors.primaryBlue;
  if (testQuota(usageType, currentUsage, usageLimit)) {
    color = theme.colors.red;
  }

  const getLimit = () => {
    const totalQuota = getTotalQuota(usageType, usageLimit);
    return totalQuota === "inf" ? (
      <InfinityIcon
        fillColor={theme.colors.midDark}
        style={{ fontSize: 20, marginLeft: 4 }}
      />
    ) : (
      totalQuota
    );
  };

  return (
    <Text
      as="div"
      type="secondary"
      style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}
    >
      <Text style={{ color, fontSize: 16, fontWeight: 500, marginRight: 4 }}>
        {currentUsage || 0}
      </Text>
      / {getLimit()}
    </Text>
  );
};

export default CurrentUsageValue;
